<template>
  <section class="wrapper" v-loading="iframeLoad" @click="showList=false">
    <div class="header-nav">
      <input type="hidden" id="topInput">
      <el-header background-color="#409EFF" fixed text-color="#fff">
        <div class="logo animation" :class="{zoom: isShowMenu}" :style="logoStyle">
          <a href="/"><img src="../../assets/images/erp_logo.png" alt=""></a>
          <span class="user-count" @click="getuserList"><i class="iconfont theme-color">&#xe663;</i><span @click="isShowUserDialog = !isShowUserDialog">{{ userList.length }}</span></span>
        </div>
        <div class="right animation" :class="{zoom: isShowMenu}">
          <!-- <el-menu :defaultActive="activeIndex[0]" background-color="#3c8dbc" text-color="#fff"
                   active-text-color="#fff" mode="horizontal" @select="menuHandleSelect" ref="menu1">
            <el-menu-item v-for="item in menuList" :key="item.id" :index="item.id">{{ item.name }}
            </el-menu-item>
          </el-menu> -->
          <ul class="top-menu" :style="headStyle">
            <li class="top-menu-item" v-for="item in menuList" :key="item.id" :index="item.id" @click="menuHandleSelect(item.id, [item.id + ''], '')"
              @mouseover="overMenu($event)" @mouseleave="leaveMenu($event)">{{ item.name }}</li>
          </ul>
          <div class="user-info">
            {{userInfo ? userInfo.username : ''}}
            <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                <img class="user-img" src="../../assets/images/user.jpg" alt="">
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="updatePassword">修改密码</el-dropdown-item>
                <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </el-header>

    </div>
    <el-dialog class="add-dialog" title="修改密码" :visible.sync="uptPassVisible" width="534px" @close="uptPassClose()">
      <el-form :model="passForm" ref="passForm">
        <el-form-item label-width="120px" label="原密码" prop="password_hash"
                      :rules="[{required:true, message:'原密码不能为空', trigger:'blur'}]">
          <el-input size="medium" type="password" v-model="passForm.password_hash" clearable></el-input>
        </el-form-item>
        <el-form-item label-width="120px" label="新密码" prop="new_password_hash"
                      :rules="[{required:true, message:'新密码不能为空', trigger:'blur'}]">
          <el-input size="medium" type="password" v-model="passForm.new_password_hash" clearable></el-input>
        </el-form-item>
        <el-form-item label-width="120px" label="确认新密码" prop="confirm_password_hash"
                      :rules="[{required:true, message:'确认新密码不能为空', trigger:'blur'}]">
          <el-input size="medium" type="password" v-model="passForm.confirm_password_hash" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" type="primary" @click="uptPassCommit">确 认</el-button>
        <el-button size="medium" @click="uptPassClose">取 消</el-button>
      </div>
    </el-dialog>
    <el-container>
      <el-aside width="200px" class="animation" :class="{zoom: isShowMenu}" :style="{backgroundColor: themeData.left_menu_bg_color}">
        <el-scrollbar :native="false" style="height: 100%;">
        <div class="menu-top" @click.stop="showList=true">
          <div class="user-info">
            <img class="user-img" src="../../assets/images/user.jpg" alt="">
            <div class="user-r" :style="{color: themeData.left_menu_font_color}">
              <p>欢迎..{{userInfo ? userInfo.position : ''}}</p>
              <p>{{userInfo ? userInfo.username : '' }}</p>
            </div>
          </div>
          <div class="search-box" :style="{backgroundColor: themeData.search_bg_color}">
            <input type="text" placeholder="Quick Menu" class="search-panel" v-model="searchKey"
              @keyup.enter='searchMenu($event)' @focus="showList = true" :style="{color: themeData.search_font_color}">
            <i slot="suffix" class="el-input__icon el-icon-search" @click="searchMenu"></i>
          </div>
          <ul class="search-list" v-show="showList && searchKey">
            <li v-for="item in searchlist" @click="showMenu(item)"><a href="javascript:;">{{ item.name
              }}【{{item.parentData.name}}】</a></li>
          </ul>
        </div>
        <p class="title" :style="mainNavStyle">MAIN NAVIGATION</p>
        <el-menu class="sub-el-menu" :defaultActive="activeIndex[1]" ref="menu2" :background-color="themeData.left_menu_bg_color"
                 :text-color="themeData.left_menu_font_color"
                 :active-text-color="themeData.left_menu_hover_color" @select="activeItem">
          <el-submenu v-for="item in subMenuList" :key="item.id" :index="item.id" :id="item.id" v-if="item.children">
            <template slot="title">
              <i class="iconfont">&#xe629;</i>
              <span>{{ item.name }}</span>
            </template>
            <el-menu-item-group v-for="subItem in item.children" :key="subItem.key">
              <el-submenu :index="subItem.id" :id="subItem.id" v-if="subItem.children">
                <template slot="title">{{ subItem.name }}</template>
                <el-menu-item v-for="i in subItem.children" :key="i.id" :index="i.route" :id="i.id">{{ i.name }}</el-menu-item>
              </el-submenu>
              <el-menu-item :index="subItem.route" :id="subItem.id" v-else>
                {{ subItem.name }}
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item :index="item.route" id="item.id" v-else>
            <i class="iconfont">&#xe629;</i>
            <span slot="title">{{item.name}}</span>
          </el-menu-item>
        </el-menu>
        </el-scrollbar>
        <a href="javascript:;" class="zoom-menu" @click="isShowMenu=!isShowMenu">
          <img class="animation" :class="{zoom: isShowMenu}" src="../../assets/images/zoom.png" alt=""></a>
      </el-aside>
      <el-main class="animation" :class="{zoom: isShowMenu}">
        <section class="nav-tags-box animation" :class="{zoom: isShowMenu}">
          <div class="nav-tags">
            <div class="tags-view-wrapper test-5">
              <span class="el-tag el-tag--mini" ref='tag' @click="currentId=0">
                <i class="circle" :class="currentId ===0?'active':''"></i>
                首页
              </span>
              <span class="el-tag el-tag--mini" ref='tag' v-for="(tag, index) in tags" :key="index"
                    @click="toTargetUrl(tag)">
                <i class="circle" :class="{ active : tag.id == currentId }"></i>
                {{ tag.name }}
                <i class="el-tag__close el-icon-close" @click.stop="closeHandle(index, tag.id)"></i>
              </span>

            </div>
            <div class="right-dropdown">
              <el-dropdown @command="handleCommand">
                <el-button type="primary" size="mini">
                  标签选项
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="all">关闭所有</el-dropdown-item>
                  <el-dropdown-item command="other">其他标签</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>

        </section>
        <div v-if="currentId==0 || currentId==''">

        </div>
        <home v-show="currentId === 0"></home>
        <div v-for="(item,index) in onloadTags" :key="item.key">
          <div v-show="currentId == item.id" :id="item.id" :currentId="currentId">
            <iframe frameborder="0" allowfullscreen :src="'/#'+item.router" style="width:100%;"
                    :style="{height: iframeHeight + 'px'}"
                    @load="iframeOnload(item.id,index)" :name="'iframe'+item.id"></iframe>
          </div>
        </div>
        <div v-for="(item,index) in unloadTags" :key="item.key">
          <div v-if="currentId == item.id" :id="item.id" :currentId="currentId">
            <iframe frameborder="0" allowfullscreen :src="'/#'+item.router" style="width:100%;"
                    :style="{height: iframeHeight + 'px'}"
                    @load="iframeOnload(item.id,index)" :name="'iframe'+item.id"></iframe>
          </div>
        </div>
      </el-main>
    </el-container>
    <el-dialog :visible.sync="isShowUserDialog" width="30%" min-height="200" >
      <div class="user-panel">
      <table class="user-list">
        <tr>
          <th>用户名</th>
          <th>首次登录时间</th>
          <th>最后操作时间</th>
        </tr>
        <tr v-for="item in userList">
          <td>{{item.username}}</td>
          <td>{{item.login_time}}</td>
          <td>{{item.last_time}}</td>
        </tr>
      </table>
      </div>
    </el-dialog>
  </section>

</template>

<script>
  import "@/assets/style/nav.scss";
  import home from "@/views/home/index.vue";

  export default {
    name: "layout",
    components: {home},
    data() {
      return {
        activeIndex: ['1', '1-1'],
        menuList: [],
        subMenuList: [],
        tags: [],
        tagIds: [],
        currentId: 0,
        opendsArr: [],
        userInfo: {
          username: "",
          position: ""
        },
        uptPassVisible: false,
        passForm: {
          username: "",
          password_hash: "",
          new_password_hash: "",
          confirm_password_hash: "",
        },
        iframeHeight: 800,
        searchKey: '',
        isStopFilter: false,
        searchlist: [],
        iframeLoad: false,
        showList: false,
        isShowMenu: false,
        userList: [],
        isShowUserDialog: false,
        themeData: {  // 换肤数据
          head_bg_img: '',
          head_bg_color: '#3C8DBC',
          head_font_color: '#fff',
          head_hover_color: '#307196',
          logo_bg_color: '#367FA8',
          logo_font_color: '#fff',
          search_bg_color: '#374850',
          search_font_color: '#fff',
          main_nav_bg_color: '#1a2226',
          main_nav_font_color: '#1a2226',
          left_menu_bg_color: '#222d31',
          left_menu_font_color: '#b8c7ce',
          left_menu_hover_color: '#fff',
        },
        headStyle: {},
        logoStyle: {},
        mainNavStyle: {},
      };
    },
    created() {
      this.$nextTick(function () {
        this.init();
      });
      this.getActiveTheme();
      this.getMenu();
      this.initSubMenuList(); // 初始化左边菜单栏
      this.getUserInfo();
      this.initUserInfo();
      this.initTags();
    },
    watch: {
      searchKey(val, old) {
        if(!val){
          this.showList = false;
        }
      }
    },
    computed: {
      onloadTags() {
        return this.tags.filter(item => {
          return item.onload;
        })
      },
      unloadTags() {
        return this.tags.filter(item => {
          return !item.onload;
        })
      }
    },
    methods: {
      // 请求换肤数据
      getActiveTheme() {
        _api.get("/auth/default-theme/active-theme").then(res => {
          if(res.code == 0) {
            this.changeTheme(res.data);
          }
        })
      },
      // 换肤
      changeTheme(data) {
        if(data.head_bg.length) this.themeData.head_bg_img = data.head_bg[0].url;
        if(data.head_background_color) this.themeData.head_bg_color = data.head_background_color;
        if(data.head_font_color) this.themeData.head_font_color = data.head_font_color;
        if(data.head_hover_color) this.themeData.head_hover_color = data.head_hover_color;
        if(data.logo_background_color) this.themeData.logo_bg_color = data.logo_background_color;
        if(data.logo_menu_font_color) this.themeData.logo_font_color = data.logo_menu_font_color;
        if(data.left_search_background_color) this.themeData.search_bg_color = data.left_search_background_color;
        if(data.left_search_font_color) this.themeData.search_font_color = data.left_search_font_color;
        if(data.main_navigation_background_color) this.themeData.main_nav_bg_color = data.main_navigation_background_color;
        if(data.main_navigation_font_color) this.themeData.main_nav_font_color = data.main_navigation_font_color;
        if(data.left_menu_background_color) this.themeData.left_menu_bg_color = data.left_menu_background_color;
        if(data.left_menu_font_color) this.themeData.left_menu_font_color = data.left_menu_font_color;
        if(data.left_menu_hover_color) this.themeData.left_menu_hover_color = data.left_menu_hover_color;
        this.headStyle = {
          backgroundImage: `url(${this.themeData.head_bg_img})`,
          backgroundColor: this.themeData.head_bg_color,
          color: this.themeData.head_font_color
        };
        this.logoStyle = {
          backgroundColor: this.themeData.logo_bg_color,
          color: this.themeData.logo_font_color
        };
        this.mainNavStyle = {
          backgroundColor: this.themeData.main_nav_bg_color,
          color: this.themeData.main_nav_font_color
        }
      },
      // 鼠标移入头部菜单栏
      overMenu(e) {
        e.srcElement.style.backgroundColor = this.themeData.head_hover_color;
      },
      // 鼠标移出头部菜单栏
      leaveMenu(e) {
        e.srcElement.style.backgroundColor = '';
      },
      init() {
        this.getuserList();
      },
      getuserList() {
        _api.get("/index/site/get-user-on-line").then(res => {
          if (res.code === 0) {
            this.userList = res.data;
          }
        });
      },
      getMenu() {
        _api.get("/auth/auth-front-route/get-all-role-route").then(res => {
          if (res.code === 0) {
            this.menuList = res.data;
          }
        });
      },
      getLogin() {
        //登陆
        _api.get("/index/site/get-login").then(res => {
          if (res.code === 0) {
            this.userInfo = res.data.data;
            lockr.set("userInfo", this.userInfo);
          }
        });
      },
      logout() {
        //登出
        _api
          .post("/index/site/login-out", {username: this.userInfo.username})
          .then(res => {
            if (res.code == 0) {
              localStorage.removeItem(`user_info`, `subMenuList`);
              lockr.rm("userInfo");
              window.location.reload();
            }
          });
      },
      updatePassword() {
        this.passForm.username = _.clone(this.userInfo.username);
        this.uptPassVisible = true;
      },
      uptPassCommit() {
        this.$refs["passForm"].validate(valid => {
          if (!valid) {
            return false;
          }
          if (this.passForm.new_password_hash !== this.passForm.confirm_password_hash) {
            this.$message.error("两次输入密码不一致!");
            return false;
          }
          _api
            .post("/index/site/reset-pass-word", this.passForm)
            .then(res => {
              if (res.code !== 0) {
                this.$message.error(res.data);
                return false;
              }
              this.$message.success('密码修改成功！');
              this.uptPassVisible = false;
            });
        });
      },
      uptPassClose() {
        this.$refs['passForm'].resetFields();
        this.uptPassVisible = false;
      },
      getUserInfo() {
        let userInfo = lockr.get("userInfo");
        if (userInfo == "" || userInfo == undefined) {
          this.$router.push({name: "login"});
          return false;
        }
        this.userInfo = lockr.get("userInfo");
      },
      initSubMenuList() {
        if (sessionStorage.getItem("subMenuList")) {
          this.showAllSubMenu();
        } else {
          this.subMenuList = [];
        }
      },

      initUserInfo() {
        this.userInfo = lockr.get("userInfo");
        if (!this.userInfo) {
          this.getLogin();
        }
      },

      menuHandleSelect(key, indexPath) {
        var mainRoute = null, parentData = null;
        this.menuList.forEach(item => {
          if (item.id == key) {
            this.subMenuList = item.children;
            parentData = JSON.parse(JSON.stringify(item));
          }
        });
        sessionStorage.setItem("subMenuList", JSON.stringify(this.subMenuList));
        this.showAllSubMenu(indexPath);
        mainRoute = JSON.parse(JSON.stringify(this.subMenuList[0]));
        mainRoute.parentData = parentData;
        if(arguments.length > 2 && !mainRoute.children && mainRoute.name.indexOf('首页') > -1 ) {
          this.$nextTick(() => {
            this.activeIndex = [key, mainRoute.route];
            this.activeItem(mainRoute.route, [mainRoute.route]);
          });
        }
      },

      // 展开全部子菜单
      showAllSubMenu() {
        this.opendsArr = [];
        this.subMenuList.forEach(item => {
          this.opendsArr.push(item.id);
        });
      },

      activeItem(targerRoute, indexPath) {
        if (this.tags.length > 15) {
          this.$message.error('打开页签过多，请关闭部分页签');
          this.iframeLoad = false;
          return;
        }
        let id = indexPath[0];
        let targerArr = [];
        let targerName = "";
        let tagId = (new Date - 0) + (parseInt(Math.random() * 1000)) + '';

        let findTargetName = (list) => {
          list.forEach(item => {
            if (item.route == targerRoute) {
              targerName = item.name;
              this.currentId = tagId;
              sessionStorage.setItem("currentId", this.currentId);
            }

            if (item.children) {
              findTargetName(item.children);
            }
          })
        }
        findTargetName(this.subMenuList);

        let tempObj = {
          router: targerRoute,
          name: targerName,
          id: tagId,
          indexPath: indexPath,
          onload: true
        };
        this.tags.push(tempObj);
        this.$nextTick(() => {
          eval('iframe' + tagId).addEventListener('load', () => {
          });
        })
        this.tagIds.push(tagId);
        sessionStorage.setItem("tags", JSON.stringify(this.tags));
      },
      iframeOnload(tagId, index) {

        let iframe = eval('iframe' + tagId);
        this.iframeLoad = false;
        if (iframe.document.getElementById('topInput')) {
          let router = this.tags[index].router;
          let indexPath = this.tags[index].indexPath;
          this.closeHandle(index);
          this.$nextTick(() => {
            this.activeItem(router, indexPath);
          });
        }

      },

      initTags() {
        this.tags = [];
        this.currentId = 0;
        this.tags.map(item => {
          this.tagIds.push(item.id);
          item.onload = this.currentId == item.id;
        })
      },

      closeHandle(index, id) {
        let tempList = JSON.parse(JSON.stringify(this.tags));

        this.currentId = tempList.hasOwnProperty(index - 1) ? tempList[index - 1].id : 0;

        this.tags.splice(index, 1);
        this.setSessionStorage();
      },

      toTargetUrl(tag) {
        this.currentId = tag.id;
        tag.onload = true;
        sessionStorage.setItem("currentId", this.currentId);
      },

      setSessionStorage() {
        sessionStorage.setItem("tags", JSON.stringify(this.tags));
        sessionStorage.setItem("currentId", this.currentId);
      },

      handleCommand(command) {
        // 关闭所有的tag
        if (command == "all") {
          this.tags = [];
          this.currentId = 0;
          this.tagIds = [0];
          this.setSessionStorage();
        }
        if (command == "other") {
          let tempArr = [];
          tempArr.push(this.tags[0]);
          for (let i = 0; i < this.tags.length; i++) {
            if (this.tags[i].id == this.currentId) {
              tempArr.push(this.tags[i]);
            }
          }
          this.tags = JSON.parse(JSON.stringify(tempArr));
          this.setSessionStorage();
        }
      },
      searchMenu(e) {
        var _that = this;
        _that.searchlist = [];
        if (_that.searchKey){
          _that.filterMenu(_that.menuList);
          _that.showSearchList();
        }
      },
      isStop() {
        var now = new Date().getTime(), diff = 0;
        this.timer = this.timer ? this.timer : 0;
        diff = now - this.timer;
        if (diff > 300) {
          this.timer = now;
          return false;
        } else {
          return true;
        }

      },
      filterMenu(menuList, parentData) {
        if (this.isStopFilter) {
          return false;
        }
        for (let i = 0; i < menuList.length; i++) {
          let v = menuList[i];
          if (v.children) {
            this.filterMenu(v.children, v);
          } else if (v.name.indexOf(this.searchKey.replace(/\s/g, '')) > -1) {
            v.parentData = JSON.parse(JSON.stringify(parentData));
            this.searchlist.push(v);

          } else {
            continue;
          }
        }
      }
      ,
      showSearchList() {
        if (this.searchlist.length == 0) {
          this.$message.closeAll();
          this.$message({
            message: this.searchKey + '菜单不存在，请重试！',
            type: 'warning'
          });
          return false;
        }
        this.showList = true;
        if(this.searchlist.length == 1) {
          this.showMenu(this.searchlist[0]);
        }

      }
      ,
      showMenu(routerData) {
        var ids = routerData.id.split('-'), _that = this,
          parentData = JSON.parse(JSON.stringify(routerData.parentData));
        this.menuHandleSelect(ids[0], [ids[0]]);
        setTimeout(function () {
          let indexPath = [];
          _that.activeIndex = [ids[0], routerData.route];
          if (ids.length > 2) {
            _that.activeIndex.push(routerData.id);
          }
          if (ids.length < 3) {
            indexPath = [routerData.route];
          } else {
            indexPath = [parentData.id, routerData.route];
            _that.$refs.menu2.open(parentData.id, parentData.children);
          }
          _that.iframeLoad = true;
          _that.activeItem(routerData.route, indexPath);
          _that.showList = false;
        }, 100);
      },
    } // methods end
  };
</script>

<style scoped="scoped">
  .header-nav {
    z-index: 100000000 !important;
  }
  .logo {
    font-family: fantasy;
    padding-left: 0 !important;
  }

  .logo a {
    display: inline-block;
    width: 100%;
    margin-left: -44px;
  }

  .logo img {
    width: 100%;
    height: auto;
  }
/*
  .is-active {
    color: #fff !important;
  } */

  .menu-top {
    position: relative;
  }

  .search-list {
    position: absolute;
    top: 99px;
    left: 8px;
    background: #374850;
    color: #fff;
    right: 9px;
    z-index: 2;
  }

  .search-list a {
    display: block;
  }

  .search-list li {
    padding: 5px 10px;
  }

  .search-list li:hover {
    background: #307196;
  }
  .el-aside:hover .zoom-menu{
    display: flex;
  }
  .zoom-menu{
    display: none;
    position: absolute;
    top: 15%;
    left: 100%;
    align-items: center;
    justify-content: center;
    background: #5e7986;
    color: #fff;
    width: 10px;
    height: 70%;
    box-shadow: 3px 0px 5px #5e7986;
  }
  .el-aside.zoom .zoom-menu, .el-aside.zoom:hover .zoom-menu{
    display: flex;
  }
  .zoom-menu img{
    height: 20px;
    width: 10px;
  }
  .zoom-menu img.zoom{
    transform: rotate(180deg);
  }
  .zoom-menu:before, .zoom-menu:after{
    position: absolute;
    left: 0;
    content: '';
    display: inline-block;
    width: 10px;
    height: 10px;
    background: #5e7986;
    box-shadow: 3px 0px 5px #5e7986;
  }
  .zoom-menu:before{
    top: -10px;
    border-radius: 0 10px 0 0 ;
  }
  .zoom-menu:after{
    bottom: -10px;
    border-radius: 0 0 10px 0;
  }
  .animation, .el-aside>*{
    transition: all ease-in-out 300ms;
    opacity: 1;
  }
  .logo.zoom, .el-aside.zoom{
    width: 0px!important;
  }
  .header-nav .el-header .right.zoom, .nav-tags-box.zoom{
    left: 0;
  }
  .el-aside.zoom>*{
    opacity: 0;
  }
  .el-aside.zoom>a{
    opacity: 1;
  }
  .el-main.zoom{
    margin-left: 14px;
  }
  .el-aside{
    height: calc(100% - 60px);
    overflow: inherit;
  }
  .user-count{
    position: absolute;
    font-size: 12px;
    cursor: pointer;
    top: 20px;
    left: 130px;
    font-family: 'arial';
  }
  .user-count i{
    margin-right: 3px;
  }
  .user-list{
    width: 100%;
  }
  .user-list th {
    font-weight: bold;

  }
  .user-list th,  .user-list td{
    line-height: 25px;
    text-align: center;
  }
  .user-panel{
    max-height: 300px;
    overflow: auto;
  }
  .top-menu {
    display: flex;
    height: 60px;
    background-repeat: no-repeat;
    background-size: cover;
    color: #fff;
  }
  .top-menu-item {
    line-height: 60px;
    padding: 0 20px;
    font-size: 16px;
    cursor: pointer;
  }
  .search-box {
    position: relative;
    height: 32px;
    padding: 0 30px 0 15px;
    background-color: #374850;
    border-radius: 4px;
  }
  .search-panel {
    width: 100%;
    height: 100%;
    background-color: transparent;
    border: none;
    outline: none;
  }
  .search-panel::-webkit-input-placeholder {
    color: #c0c4cc;
	}
  .search-panel:-moz-placeholder {
    color: #c0c4cc;
	}
  .search-panel:-ms-input-placeholder {
    color: #c0c4cc;
	}
  .search-box i {
    position: absolute;
    right: 4px;
    bottom: 2px;
    color: #c0c4cc;
  }
</style>
<style>
  .animation .el-scrollbar__wrap {
    overflow-x: hidden;
  }
</style>




// WEBPACK FOOTER //
// index.vue?7195b3fa